import { createGlobalStyle, css } from "styled-components";
import { breakpoints } from "./breakpoints";

export const GlobalStyles = createGlobalStyle`
  ${({ theme }) => css`
    ::-webkit-scrollbar {
      width: 10px;
      height: 10px;

      @media (max-width: ${breakpoints.md}) {
        width: 3px;
        height: 3px;
      }
    }

    ::-webkit-scrollbar-track {
      background: ${theme.scroll.trackColor};
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.scroll.thumbColor}EE;

      :hover {
        background: ${theme.scroll.thumbColor}AA;
      }
    }

    a:hover {
      opacity: 0.7;
    }

    .grecaptcha-badge {
      visibility: hidden;
    }

    .inline {
      display: inline;
    }

    .fill {
      flex: 1;
    }

    .mt-10 {
      margin-top: 10px;
    }

    .mt-15 {
      margin-top: 15px;
    }

    .mt-20 {
      margin-top: 20px;
    }

    .mr-10 {
      margin-right: 10px;
    }

    .mr-15 {
      margin-right: 15px;
    }

    .mb-10 {
      margin-bottom: 10px;
    }

    .mb-15 {
      margin-bottom: 15px;
    }

    .mb-20 {
      margin-bottom: 20px;
    }

    .mb-30 {
      margin-bottom: 30px;
    }

    .mb-40 {
      margin-bottom: 40px;
    }

    .ml-30 {
      margin-left: 30px;
    }

    .uppercase {
      text-transform: uppercase;
    }
  `};
`;
